const organizationRoles = [
  { value: true, title: 'organization_admin' },
  { value: false, title: 'organization_user' },
];

export { organizationRoles };
